import DashboardSidePanel from './DashboardSidePanel'

export default DashboardSidePanel
